function toCurrency(numberString) {
  const number = parseFloat(numberString);
  return number.toLocaleString('es-AR');
}

export default toCurrency;
